import { translate } from "app/filters/i18nFilter";
import { StyledParenthesisedContent } from "app/pages/sales-intelligence/common-components/styles";
import trackingService from "app/pages/sales-intelligence/sub-modules/advanced-search/services/tracking/advancedSearchTrackingService";

import { StyledButton } from "./styles";

type Props = {
    onClick?(): void;
    count?: number;
    isDisabled?: boolean;
};

const SavedSearchesOverlayToggle = (props: Props) => {
    const numberOfSavedSearches = props.count || 0;

    const showSavedSearchesCounter = numberOfSavedSearches > 0;

    const handleButtonClick = () => {
        if (props.isDisabled) {
            return;
        }

        trackingService.quickSearches.trackOverlayOpened();

        props.onClick?.();
    };

    return (
        <StyledButton
            type="flat"
            isDisabled={props.isDisabled}
            dataAutomation="saved-searches-toggle-button"
            onClick={handleButtonClick}
        >
            {translate("si.lead_gen_filters.button.saved_searches")}

            {showSavedSearchesCounter ? (
                <StyledParenthesisedContent>{numberOfSavedSearches}</StyledParenthesisedContent>
            ) : null}
        </StyledButton>
    );
};

export default SavedSearchesOverlayToggle;
